import * as CSS from "csstype"
import { style } from "styled-system"

interface OwnProps {
  aspectRatio?: CSS.Property.AspectRatio | CSS.Property.AspectRatio[]
}

export type AspectRatioProps = OwnProps

const aspectRatio = style({
  prop: "aspectRatio",
  cssProperty: "aspect-ratio",
})

export default aspectRatio
